import moment from "moment";
import Utils from "@/utils";
import CreateEditOpenDays from "@/components/createEditOpenDays/createEditOpenDays.vue";
import openClosedDateItem from "@/components/openClosedDateItem/openClosedDateItem.vue";
import ExceptionalDateItem from "@/components/exceptionalDateItem/exceptionalDateItem.vue";
import CreateEditExceptionalClosedDays from "@/components/createEditExceptionalClosedDays/createEditExceptionalClosedDays.vue";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	components: {
		CreateEditOpenDays,
		CreateEditExceptionalClosedDays,
		openClosedDateItem,
		ExceptionalDateItem,
	},

	data() {
		return {
			showOpenDays: false,
			showCreateOpenDays: false,
			showCloseDays: false,
			showCreateExcepitionalDays: false,
		};
	},

	computed: {
		...userGetters(["openClosedDays", "exceptionalClosedDays"]),

		// open closing dates
		futureClosedDays,
		pastClosedDays,

		// exceptional closing dates
		futureExceptionalCloseDays,
		pastExceptionalCloseDays,
	},
};

function futureClosedDays() {
	const YESTERDAY = moment().subtract(1, "days");
	return this.openClosedDays
		.filter((closeDay) => (closeDay.end_date && moment(closeDay.end_date).isAfter(YESTERDAY)) || !closeDay.end_date)
		.sort()
		.map(Utils.addUniqueKey);
}

function pastClosedDays() {
	const YESTERDAY = moment().subtract(1, "days");
	return this.openClosedDays
		.filter((closeDay) => closeDay.end_date && moment(closeDay.end_date).isBefore(YESTERDAY))
		.sort()
		.map(Utils.addUniqueKey);
}

function futureExceptionalCloseDays() {
	const ONE_DAY = 1,
		YESTERDAY = moment().subtract(ONE_DAY, "days");

	return (
		this.exceptionalClosedDays
			// show only dates in future
			.filter((date) => moment(date.end_date).isAfter(YESTERDAY))
			// reverse the array, so dates are sorted by ascending order
			.reverse()
			.map(Utils.addUniqueKey)
	);
}

function pastExceptionalCloseDays() {
	const ONE_DAY = 1,
		YESTERDAY = moment().subtract(ONE_DAY, "days");

	return this.exceptionalClosedDays.filter((date) => moment(date.end_date).isBefore(YESTERDAY)).map(Utils.addUniqueKey);
}
